import { EventqDataTableColumn } from '@ecam/eventq-components';

/**
 * Shared switch for the Events, Patrol, Parked Events, and Events in Process tables.
 * Set to `true` to show sort icons and apply column sorting again.
 * Alarm and arm/disarm tables are not controlled by this flag.
 */
export const QUEUE_TABLES_SORTABLE = false;

export function queueTableColumn(
  column: Omit<EventqDataTableColumn, 'sortable'>,
  sortable = QUEUE_TABLES_SORTABLE,
): EventqDataTableColumn {
  return { ...column, sortable };
}

/** Drops a stored queue sort while {@link QUEUE_TABLES_SORTABLE} is off. */
export function activeQueueSort<T>(sort: T | null, enabled = QUEUE_TABLES_SORTABLE): T | null {
  return enabled ? sort : null;
}
